import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { GridColDef } from '@mui/x-data-grid-pro';

export const useGetColumns = () => {
  const { t } = useTranslation();

  return useMemo<GridColDef[]>(
    () => [
      {
        headerName: t('dtrRules.column.enabled'),
        field: 'enabled',
        type: 'boolean',
        width: 80,
        renderCell: ({ value }) => <BooleanCell value={value} />
      },
      {
        headerName: t('dtrRules.column.name'),
        field: 'name',
        type: 'string',
        hideable: false,
        valueGetter: (value: string) => {
          return t(`dtrRules.rule.${value}`)
        },
        flex: 1
      }
    ],
    []
  );
};
